import Vue from 'vue'

/**
 * vue组件创建地图弹框
 * @param {component} component vue组件
 * @param {Object} propsData vue组件props传值
 * @returns {Document} dom节点
 */
export const drawDialog = (component, propsData = {}) => {
  // 利用Vue.extend扩展vue组件
  const WindowConstroctor = Vue.extend(component);
  // 此处实例化
  const domEl = new WindowConstroctor({
    el: document.createElement('div'),
    propsData
  });

  domEl.show = true;
  return domEl.$el
}